<template>
  <div>
    <el-dialog title="选择优惠券" :visible.sync="dialogPrize" width="1050px" @close="dialogClose">
      <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick" v-if="libaoItem.name == '东券' || libaoItem.name == '京券'">
        <el-tab-pane label="店铺内部券" name="first" v-if="inShopShow">
          <div class="tip">
            <span class="desc">
              <i class="el-alert__icon el-icon-info"></i>
              <span v-if="this.libaoItem.num === 0">
                注：优惠券类型推荐选择【免费领取】【不公开】【全平台】的优惠券。
                <span @click="jumpCreation" style="color: #7B61FF;cursor: pointer;">创建优惠券> </span>
                <span style="color: #999999;">优惠券创建教程> </span>
              </span>
              <span v-else>
                注：优惠券类型推荐选择【互动平台】的优惠券。
                <span @click="jumpCreation" style="color: #7B61FF;cursor: pointer;">创建优惠券> </span>
                <span style="color: #999999;">优惠券创建教程> </span>
              </span>
              <span style="display: block;padding-left: 47px;padding-top: 10px;color: red" v-if="venderType"
                >抱歉，此类型奖品暂时不支持自营店铺！
              </span>
            </span>
          </div>
          <el-form :model="formList" label-width="120px" style="margin-top:20px">
            <el-row :gutter="15" style="margin-left: -40px;">
              <el-col :span="8">
                <el-form-item label="类型:" v-if="libaoItem.num === 0">
                  <el-select v-model="formList.type" placeholder="请选择" style="width: 200px">
                    <el-option label="京券" value="0"></el-option>
                    <el-option label="东券" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="类型:" v-else>
                  <el-select v-model="formList.type" placeholder="请选择" style="width: 200px">
                    <el-option v-if="libaoItem.name == '京券'" label="京券" value="0"></el-option>
                    <el-option v-if="libaoItem.name == '东券'" label="东券" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发放类型:">
                  <el-select v-model="formList.grantType" placeholder="请选择" style="width: 200px">
                    <el-option
                      v-for="item in labelList"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                      :key="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="是否公开:">
                  <el-select v-model="formList.display" placeholder="请选择" style="width: 200px">
                    <el-option label="不公开" value="1"></el-option>
                    <el-option label="公开" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-left: -40px;">
              <el-col :span="8">
                <el-form-item>
                  <div style="margin-left: -88px">
                    <el-button size="small" class="search" @click="handleSearch('1')">
                      <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
                      查询
                    </el-button>
                    <el-button size="small" class="reset" @click="handleReset('1')">重置</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table
            v-loading="tableLoading"
            :data="internalTable"
            style="width: 100%"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
            empty-text="暂无优惠券，请先创建"
          >
            <el-table-column prop="name" label="名称" width="200">
              <template slot-scope="scope">
                <div>{{ scope.row.name }}</div>
                <div class="couponTypebox">{{ scope.row.couponType == 1 ? "店铺券" : "商品券" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="有效期" width="260">
              <template slot-scope="scope">
                <span>起:{{ scope.row.beginTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="剩余量(张)" prop="leftNum"> </el-table-column>
            <el-table-column label="面额/使用条件">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.discount ? scope.row.discount + "元" : ""
                  }}{{ scope.row.quota ? "/满" + scope.row.quota + "元" : scope.row.quota == 0 ? "/满0元" : "" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button style="width: 50px;" type="text" class="Notetake" @click="chooseTab(scope.row)">
                  选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            background
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            :current-page="1"
          ></el-pagination>
        </el-tab-pane>
        <el-tab-pane label="店铺外部券" name="second" v-if="outShopShow">
          <div class="tip">
            <span class="desc">
              <i class="el-alert__icon el-icon-info"></i>
              <span
                >注：外部优惠券需要手动添加。 <span @click="jumpSansCreation" style="color: #7B61FF;cursor: pointer;">添加外部优惠券> </span>
                &nbsp;&nbsp;<span style="color: #7B61FF;cursor: pointer;" v-if="$route.name == 'superFissionDivine'">添加发放型优惠券教程> </span>
              </span>
              <br />
              <span style="line-height: 20px;margin-top: 4px;display: inline-block;">
                根据平台规定，免费领取优惠券不支持直接发放到买家账号，必须通过链接点击领取，请商家明确活动成本预算，防止优惠券链接被恶意分享的风险；自动发放类型的优惠券可直接发放到用户账户。
              </span>
            </span>
          </div>
          <el-form :model="formListTwo" label-width="120px" style="margin-top:20px">
            <el-row :gutter="20" style="margin-left: -40px;">
              <el-col :span="8">
                <el-form-item label="优惠券名称:">
                  <el-input v-model="formListTwo.name" placeholder="请输入" style="width: 200px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="优惠券面额:">
                  <el-input v-model="formListTwo.discount" placeholder="请输入" style="width: 200px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发放方式:">
                  <el-select v-model="formListTwo.issueType" style="margin-right: 10px;" placeholder="请选择">
                    <el-option label="免费抢券" :value="0" disabled />
                    <el-option label="自动发放" :value="1" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-col :span="6" style="margin-bottom: 20px;">

              <el-button size="small" class="search" @click="handleSearch('2')">
                <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
                查询
              </el-button>
              <el-button size="small" class="reset" @click="handleReset('2')">重置</el-button>

            </el-col>
          </el-form>
          <el-table
            v-loading="tableLoading"
            :data="externalTable"
            style="width: 100%"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column prop="name" label="名称" width="200"> </el-table-column>
            <el-table-column label="有效期" width="240">
              <template slot-scope="scope">
                <span>起:{{ scope.row.beginTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="面额/使用条件">
              <template slot-scope="scope">
                <span> {{ scope.row.discount ? scope.row.discount + "元/" : "" }}{{ scope.row.quota ? "满" + scope.row.quota + "元" : "" }} </span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button style="width:50px;margin-left: -10px;" class="Notetake" type="text" @click="chooseTab(scope.row)">
                  选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChangeTwo"
            background
            @current-change="handleCurrentChangeTwo"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNumTwo"
            :current-page="1"
          ></el-pagination>
        </el-tab-pane>
      </el-tabs> -->
      <div v-if="libaoItem.name == '东券' || libaoItem.name == '京券'">
          <input-form
            ref="inputForms"
            :inputData="inputDataTwo"
            :btnPosition1="true"
            @toParentVal="searchContentTwo"
          ></input-form>
          <div style="margin: 0px 0px 12px 30px;">
            <el-button v-if="venderType" style="width: auto;background-color:#7b61ff;color:white;border: 1px solid #7b61ff" @click="handleAddCoupon2">添加发放型外部券</el-button>
            <el-button v-else  style="width: auto;background-color:#7b61ff;color:white;border: 1px solid #7b61ff" @click="handleAddCoupon">创建发放型优惠券</el-button>
          </div>
          <el-table
                v-loading="tableLoading"
                :data="externalTable"
                style="width: 100%;"
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }"
                class="selectTable"
              >
                <el-table-column prop="name" label="优惠券名称"> </el-table-column>
                <el-table-column prop="name" label="优惠券信息" width="150"> 
                  <template slot-scope="scope">
                    <span v-if="scope.row.couponKind == 0">全品类东券,</span>
                    <span v-if="scope.row.couponKind == 1">限品类京券,</span>
                    <span v-if="scope.row.couponKind == 2">店铺东券,</span>
                    <span v-if="scope.row.couponKind == 3">限商品东券,</span>
                    满{{ scope.row.quota }}减{{ scope.row.discount }}元
                  </template>
                </el-table-column>
                <el-table-column :prop="venderType?'putkey':'couponIdOrPutKey'" label="优惠券id/key" width="100"> </el-table-column>

                <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
                <el-table-column label="领取时间" width="180">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.takeBeginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.takeEndTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="balanceNum" label="剩余数量" width="130"> </el-table-column>
                <el-table-column prop="status" label="奖品状态" width="130"> 
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">未开始</span>
                <span v-if="scope.row.status == 2">进行中</span>
                <span v-if="scope.row.status == 3">已结束</span>
              </template>
            </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">

                    <el-button
                      style="width: 50px;margin-left: -10px;color: #7B61FF;"
                      class="Notetake"
                      type="text"
                      @click="
                        chooseTab(scope.row);
                        dialogVisibleFrom = false;
                      "
                    >
                      选择
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align: right; margin-top: 20px"
                @size-change="handleSizeChangeTwo"
                background
                @current-change="handleCurrentChangeTwo"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNumTwo"
                :current-page="1"
              ></el-pagination>
          <div style="color: #7B61FF; padding: 20px 0 20px 40px">
            <!-- 注：此类型奖品暂时不支持自营店铺 -->
          </div>
        </div>
      <template v-else>
        <div class="tip">
          <span class="desc">
            <i class="el-alert__icon el-icon-info"></i>
            <span v-if="libaoItem.name == '京豆'">注意：为保证活动奖品正常发放，建议选择发豆规则与奖品发放规则一致的计划。</span>
            <span v-if="libaoItem.name == '店铺积分'">注：店铺积分：发放积分需要加入京东会员体系，并开通积分功能</span>
          </span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" style="margin-top:20px">
          <!--京豆  -->
          <template v-if="libaoItem.name == '京豆'">
            <el-form-item label="选择京豆计划:">
              <!-- <el-input v-model="ruleForm.activityName" style="width: 200px"></el-input> -->
              <el-select v-model="ruleForm.activityName" placeholder="请选择" @change="planChange" style="width: 200px">
                <el-option v-for="(item, index) in selectList" :key="index" :label="item.label" :value="item"></el-option>
              </el-select>
              <span class="shuaxin pointer" @click="sxJingdou"> 刷新</span>
              <span class="chuangjian pointer" @click="jumpJingduo">创建京豆计划</span>
              <div v-show="activeSendtimes">
                <span>京豆计划的发豆次数，最多</span>
                <span style="color:#7B61FF"> {{ activeSendtimes }} </span>次
              </div>
            </el-form-item>

            <el-form-item label="单份奖励个数:">
              <el-input v-model="ruleForm.singleAmount" @input.native="checkputn" placeholder="请输入" style="width: 140px"></el-input>
              个京豆（每人每次发送的京豆个数）
            </el-form-item>
          </template>
          <!-- 店铺积分  -->
          <el-form-item label-width="92px" label="积分数量:" v-if="libaoItem.name == '店铺积分'">
            <el-input v-model="ruleForm.point" @input.native="checkputn" placeholder="请输入" style="width: 200px"></el-input>
          </el-form-item>
        </el-form>
        <div class="enter pointer" @click="handleConfirm">
          {{ libaoItem.name == "店铺积分" ? "选择店铺积分奖品" : "选择京豆发放" }}
        </div>
      </template>
      <add-coupon :isSuperFission="true" :isShow="addCouponIsShow" @close="addCouponIsShow = false" @funcMes="addStatus"></add-coupon>
    <add-coupon2 :isShow="addCouponIsShow2" @close="addCouponIsShow2 = false" @funcMes="addStatus2"></add-coupon2>
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import SelectGoods from "@/components/selectGoodsMonitor";
import { mapState } from "vuex";
// import { getShopGif } from "@/api/paradiseAndTaskCommonController.js";
import { couponList, jingdouList, allAccountList, redPacketList, judgingActivation } from "@/api/integralCenter/prizeCenter.js";
import { querySellerCouponWriteList, querySellerCouponExternalList,createSellerCouponWrite } from "@/api/integralCenter/couponWriteController";
import addCoupon from '../../integralCenter/add_coupon1.vue'
import addCoupon2 from '../../integralCenter/add_coupon2.vue'
export default {
  name: "selectPrize",
  components: {
    SelectGoods,
    addCoupon,
    addCoupon2,
    inputForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    inShopShow: {
      type: Boolean,
      default: true,
    },
    outShopShow: {
      type: Boolean,
      default: false,
    },
    libaoItem: {
      type: Object,
      default() {
        return {
          name: "东券",
          num: 0,
        };
      },
    },
    //typeDefault可不传 默认京券 免费领取 不公开
    typeDefault: {
      type: Object,
      default() {
        return {
          grantType: 3, // 发放类型  传对应的id值
          display: 1, // 是否公开  传对应的id值
          type: 0, // 不禁用  传对应的id值
          noDisabled: [3], // 不禁用  传对应的id值  可不传（默认全部禁用）
        };
      },
    },
    // num != 2 JingdouCount中的prizeCount必传 计算填的京豆总数是否大于京豆总数
    JingdouCount: {
      type: Object,
      default() {
        return {
          prizeCount: 0,
        };
      },
    },
    num: {
      default: 2,
    },
  },
  computed: {
    ...mapState(["venderType"]),
  },
  watch: {
    async value(val) {
      // this.quireList();
      if (val) {
        if (this.libaoItem && this.libaoItem.num === 0) {
          // 配置优惠券查询走这里 可默认
          this.formList.type = String(this.typeDefault.type);
          this.formList.display = String(this.typeDefault.display);
          this.formList.grantType = String(this.typeDefault.grantType);
          if (this.typeDefault && this.typeDefault.noDisabled) {
            this.labelList.forEach((item) => {
              this.typeDefault.noDisabled.forEach((i) => {
                if (item.value == i) {
                  item.disabled = false;
                } else {
                  item.disabled = true;
                }
              });
            });
          }
          if (this.outShopShow && !this.inShopShow) {
            this.activeName = "second";
            this.querySellerCouponExternal();
          }
          this.quireList();
        } else {
          // 店铺礼包另外  不动 已些死
          if (this.libaoItem.prizeType == "4") {
            this.ruleForm.singleAmount = this.libaoItem.singleAmount;
            if (this.libaoItem.assetsId) {
              this.formLitJD.id = this.libaoItem.assetsId;
              const res = await jingdouList(this.formLitJD);
              this.selectList = res.data.records.map((item) => ({
                label: item.planName,
                value: item.id,
                sendTimes: item.sendTimes,
              }));
              this.planList.jingdou = res.data.records;
              this.ruleForm.activityName.label = res.data.records[0].planName;
              this.ruleForm.activityName.value = res.data.records[0].id;
              this.ruleForm.activityName.sendTimes = res.data.records[0].sendTimes;
            } else {
              this.getJingdouList();
            }
            // this.getJingdouList();
          }
          if (this.libaoItem.prizeType == "6") {
            this.ruleForm.point = this.libaoItem.singleAmount;
          }
          if (this.libaoItem.prizeType == "0" || this.libaoItem.prizeType == "1") {
            this.formList.type = this.libaoItem.prizeType;
            this.formList.grantType = "5";
            this.formList.display = "1";
            this.typeDefault.type = "0";
            this.typeDefault.display = "1";
            this.typeDefault.grantType = "5";
            this.labelList[4].disabled = false;
            this.quireList();
          }
        }
      }
      this.dialogPrize = val;
    },
  },
  created() {},
  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.inputForms.formSearch();
    // });
  },
  data() {
    return {
      echoDate: {},
      addCouponIsShow: false,
      inputDataTwo: [
        {
          name: "优惠券名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券id/key:",
          val: "couponIdOrPutKey",
          placeholder: "请输入",
        },
        {
          name: "奖品状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "优惠券使用范围:",
          val: "couponKind",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "全店", id: 2 },
            { label: "商品", id: 3 },
            { label: "全品类", id: 0 },
            { label: "限品类", id: 1 },
          ],
        },
        {
          name: "创建时间:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
      awardSettingsLsit: [
        {
          prizeType: 1,
          price: null,
          title: "",
          singleAmount: null,
          totalAmount: "",
          inviteNum: null,
          takeEndTime: null,
          takeBeginTime: null,
          isMain: 1,
          quota: null,
        },
      ],
      FissionVoucherList: [],
      addCouponIsShow2: false,

      isPointsEnabled: false,
      labelList: [
        { label: "促销绑定", value: "1", disabled: true },
        { label: "推送", value: "2", disabled: true },
        { label: "免费领取", value: "3", disabled: true },
        { label: "京豆换券", value: "4", disabled: true },
        { label: "互动平台", value: "5", disabled: true },
      ],
      dialogPrize: false,
      selectList: [],
      ruleForm: {
        activityName: {},
        singleAmount: "",
        point: "",
      },
      jingdouData: {},
      rules: {},
      activeName: "first",
      internalTable: [],
      externalTable: [],
      totalNum: 0,
      totalNumTwo: 0,
      formList: {
        current: 1,
        size: 10,
        isCustomize:1,
        type: "",
        display: "",
        grantType: "",
      },
      formListTwo: {
        current: 1,
        size: 10,
        isCustomize:1,
        issueType: 1,
      },
      // 京豆
      formLitJD: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      activeSendtimes: "",
      planList: {
        jingdou: {},
      },
      tableLoading: false,
    };
  },
  methods: {
    handleSizeChange2(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChange2(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    addStatus(val) {
      let obj = val
      createSellerCouponWrite(obj)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.$refs.inputForms.formSearch();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
      // this.awardSettingsLsit[0].assetsId = data
      return
      if (this.isMain == 1) {
        this.awardSettingsLsit[0].innerCouponDto = val;
        this.awardSettingsLsit[0].quota = val.quota;
        this.awardSettingsLsit[0].beginTime = val.takeBeginTime;
        this.awardSettingsLsit[0].endTime = val.takeEndTime;
        this.awardSettingsLsit[0].totalAmount = val.num;
        this.awardSettingsLsit[0].title = val.name;
        this.awardSettingsLsit[0].price = val.discount;
        this.awardSettingsLsit[0].couponType = val.bindType;
        this.awardSettingsLsit[0].singleAmount = 1;
      } else {
        // if (this.superSplitCoupon) {
        //   this.FissionVoucherList[0].innerCouponDto = val;
        //   this.FissionVoucherList[0].quota = val.quota;
        //   this.FissionVoucherList[0].beginTime = val.takeBeginTime;
        //   this.FissionVoucherList[0].endTime = val.takeEndTime;
        //   this.FissionVoucherList[0].totalAmount = val.num;
        //   this.FissionVoucherList[0].title = val.name;
        //   this.FissionVoucherList[0].price = val.discount;
        //   this.FissionVoucherList[0].couponType = val.type;
        // } else {
        this.FissionVoucherList[this.indexCoupon].quota = val.quota;
        this.FissionVoucherList[this.indexCoupon].beginTime = val.takeBeginTime;
        this.FissionVoucherList[this.indexCoupon].endTime = val.takeEndTime;
        this.FissionVoucherList[this.indexCoupon].totalAmount = val.num;
        this.FissionVoucherList[this.indexCoupon].title = val.name;
        this.FissionVoucherList[this.indexCoupon].price = val.discount;
        this.FissionVoucherList[this.indexCoupon].couponType = val.bindType;
        this.FissionVoucherList[this.indexCoupon].innerCouponDto = val;
        this.FissionVoucherList[this.indexCoupon].singleAmount = 1;

        console.log(this.FissionVoucherList, 111111);
        // }
      }
    },
    addStatus2() {
      this.$refs.inputForms.formSearch();
    },
    searchContentTwo(val) {
      console.log(val);
      this.formListTwo = {
        current: '1',
        isCustomize:1,
        ...val
      }
      // this.formListTwo.current = "1";
      // this.formListTwo.name = val.name;
      // this.formListTwo.discount = val.discount;
      // this.formListTwo.beginTime = val.beginTime;
      // this.formListTwo.endTime = val.endTime;
      // this.formListTwo.issueType = val.issueType;

      this.querySellerCouponExternal();
    },
    handleAddCoupon() {
      this.addCouponIsShow = true
      // this.echoDate = {}
    },
    handleAddCoupon2() {
      this.addCouponIsShow2 = true
      // this.echoDate2 = {}
    },
    handlelink() {
      window.open("https://member.shop.jd.com/index/newmemberlevel");
    },
    // 积分  京东发放
    handleConfirm() {
      // this.ruleForm.prizeType =
      let params = {
        ...this.ruleForm,
        prizeType: this.libaoItem.prizeType,
      };
      if (this.libaoItem.prizeType == "4") {
        if (!this.ruleForm.activityName.value || !this.ruleForm.singleAmount) {
          return this.$message.warning("请填写完整");
        }
      }
      if (this.libaoItem.prizeType == "6") {
        if (!this.ruleForm.point) {
          return this.$message.warning("请填写积分");
        }
      }
      let jingdouPlanList = null;
      let item = {};
      if (this.libaoItem.name == "京豆") {
        let line = this.JingdouCount;
        jingdouPlanList = this.planList.jingdou;
        item = jingdouPlanList.find((i) => {
          return i.id == this.jingdouData.couponId;
        });
        if (item) {
          if ( this.venderType &&
            line.prizeCount &&
            this.ruleForm.singleAmount &&
            Number(line.prizeCount) * Number(this.ruleForm.singleAmount) > Number(item.quantityTotal)
          ) {
            this.$message.error("京豆发放数量不能大于该京豆预算额！");
            return;
          }
          if (this.ruleForm.singleAmount && Number(this.ruleForm.singleAmount) > Number(item.quantityTotal)) {
            this.$message.error("单份奖励个数不能大于该京豆预算额！");
            return;
          }
          if (!this.ruleForm.singleAmount) {
            this.$message.error("请填写京豆单份奖励个数！");
            return;
          }
          // if (!line.prizeCount) {
          //   this.$message.error("京豆奖励需先填写奖品总份额！");
          //   return;
          // }
        }
      }
      // console.log(params, 555);
      this.$emit("closePrize", true, { ...params, quantityTotal: item.quantityTotal });
    },
    // 京东券
    chooseTab(item) {
      let params = item;
      params.prizeType = this.libaoItem.prizeType;
      params.name = item.discount + "元优惠券";
      params.id = item.assetsId
      params.couponId = item.assetsId
      // console.log(params);
      this.$emit("closePrize", true, params);
    },
    sxJingdou() {
      this.formLitJD = {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 4,
      };
      this.getJingdouList();
    },
    //查询京豆
    async getJingdouList() {
      const res = await jingdouList(this.formLitJD);
      let selectArr = res.data.records.map((item) => {
        return {
          label: item.planName,
          value: item.id,
          sendTimes: item.sendTimes,
        };
      });
      this.selectList = selectArr;
      this.planList.jingdou = res.data.records;
    },
    //获取优惠券
    quireList() {
      // this.formList.beginTime = this.nowTime;
      // this.querySellerCouponExternal()
      setTimeout(() => {
        this.$refs.inputForms.formSearch();
      }, 100);
      return
      this.tableLoading = true;
      couponList(this.formList).then((res) => {
        this.internalTable = res.data.records;
        this.internalTable.forEach((item) => {
          item.couponType = 1;
        });
        this.totalNum = Number(res.data.total);
        this.tableLoading = false;
      });
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      console.log(111,this.formListTwo)
      querySellerCouponExternalList(this.formListTwo).then((res) => {
        this.externalTable = res.data.records;
        this.externalTable.forEach((item) => {
          // item.couponType = 2;
          item.couponId = Number(item.id);
        });
        this.totalNumTwo = Number(res.data.total);
        this.tableLoading = false;
      });
    },
    //切换
    handleTabClick(val) {
      // console.log(val);
      if (val.name == "second") {
        this.querySellerCouponExternal();
      }
    },
    // 创建内部优惠券
    jumpCreation() {
      window.open("https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F");
    },
    // 创建外部优惠券
    jumpSansCreation() {
      this.$router.push({
        path: "../prizeCenter/coupon_management",
        query: { to: 1 },
      });
    },
    // 创建京豆
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    //  内部搜索
    handleSearch(val) {
      if (val == "1") {
        this.quireList();
      } else {
        // 外部
        this.querySellerCouponExternal();
      }
    },
    // 重置
    handleReset(val) {
      if (val == "1") {
        if (this.libaoItem.num === 0) {
          this.formList.type = String(this.typeDefault.type);
        }
        // this.formList.type = "";
        this.formList.grantType = String(this.typeDefault.grantType);
        this.formList.display = String(this.typeDefault.display);
        this.quireList();
      } else {
        this.formListTwo.name = "";
        this.formListTwo.discount = "";
        this.querySellerCouponExternal();
      }
    },
    planChange(val) {
      console.log(val);
      this.activeSendtimes = val.sendTimes;

      this.jingdouData = {
        couponId: val.value || "",
        // discount: this.jingduoForm.quota,
        discount: Number(val.count || ""),
        name: val.label || "",
        singleAmount: Number(val.count || ""),
      };
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handleSizeChangeTwo(val) {
      this.formListTwo.size = val;
      this.querySellerCouponExternal()
    },
    handleCurrentChangeTwo(val) {
      this.formListTwo.current = val;
      this.querySellerCouponExternal()
    },
    dialogClose() {
      this.$emit("closePrize", false);
    },
  },
};
</script>

<style scoped lang="scss">
.couponTypebox {
  background: green;
  width: 52px;
  color: #fff;
  margin: 0 auto;
  padding: 0px 4px;
  font-size: 12px;
}
.pointer {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.tip {
  width: 100%;
  // height: 44px;
  background: #fafafa;
  border-radius: 4px;
  padding: 15px 0 15px 12px;
  .desc {
    i {
      opacity: 0.7;
      color: #7b61ff;
    }
    color: #999;
  }
}
.enter {
  width: 104px;
  height: 32px;
  padding: 0 10px;
  background: #7b61ff;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  margin-top: 26px;
  color: #ffffff;
  margin-left: 20px;
}
.shuaxin {
  display: inline-block;
  line-height: 32px;
  position: relative;
  padding-left: 22px;
  margin-left: 10px;
  &::before {
    width: 20px;
    height: 20px;
    background: url("../../../assets/images/integralCenter/shuaxin.png");
    position: absolute;
    left: 0px;
    content: "";
    top: 5px;
  }
}
.chuangjian {
  margin-left: 10px;
  display: inline-block;
  width: 104px;
  height: 32px;
  background: #7b61ff;
  border: 1px solid #7b61ff;
  line-height: 32px;
  color: #fff;
  text-align: center;
  border-radius: 4px;
}
.search {
  color: #fff;
  border: 1px solid #7b61ff;
  background-color: #7b61ff;
  &:hover {
    opacity: 0.8;
  }
}
.reset {
  color: #7b61ff;
  border: 1px solid #7b61ff;
  background-color: #fff;
  &:hover {
    color: #fff;
    border: 1px solid #7b61ff;
    background-color: #7b61ff;
  }
}
/deep/.selectTable{
  .el-table__body-wrapper{
    height: 275px;
    overflow: auto;
  }
}
</style>
